/**
 * @file This file contains the logic to adapt different product personalization data structures
 * into a single, standardized format. This makes backend processing much simpler and more robust.
 */

const PersonalizationAdapter = {
    /**
     * Transforms data from the 'group' template into the standard format.
     * @param {object} groupData - The raw data object from the group template script.
     * @returns {object} - The data in the standardized format.
     */
    transformGroupData: function() {
        const platingColorSelect = document.querySelector('#plating-color');
        const countSelect = document.querySelector('#inscription-count');

        const additionalData = {
            options: {
                group: {},
                engravings: [],
                platingColor: {},
                stones: []
            }
        };

        // 1. Populate Plating Color
        if (platingColorSelect && platingColorSelect.value) {
            const selectedOption = platingColorSelect.options[platingColorSelect.selectedIndex];
            additionalData.options.platingColor = {
                type: 'select',
                value: platingColorSelect.value,
                label: selectedOption.textContent.trim(),
                price: 0
            };
        }

        // 2. Populate Group Selection
        const selectedCount = countSelect ? parseInt(countSelect.value) : 0;
        if (selectedCount > 0) {
            const selectedOption = countSelect.options[countSelect.selectedIndex];
            additionalData.options.group = {
                type: 'select',
                value: selectedCount,
                label: selectedOption.getAttribute('data-label') || selectedOption.textContent.trim(),
                price: parseFloat(selectedOption.getAttribute('data-price') || 0),
                basePrice: parseFloat(selectedOption.getAttribute('data-price') || 0)
            };
        }

        // 3. Collect Engravings and Stones
        for (let i = 1; i <= selectedCount; i++) {
            debugger
            const engravingInput = document.getElementById(`inscription-${i}`);
            const groupElement = document.querySelector(`.birthstone-group[data-group="${i}"]`);
            const birthstoneInput = groupElement ? groupElement.querySelector(`input[name="properties[Stone${i}]"]`) : null;
            const birthstoneDisplay = document.getElementById(`birthstone-${i}-selectedText`);

            // Add engraving
            if (engravingInput && engravingInput.value.trim() !== '') {
                additionalData.options.engravings.push({
                    index: i,
                    value: engravingInput.value.trim(),
                    font: null
                });
            }

            // Add birthstone
            if (birthstoneInput && birthstoneInput.value.trim() !== '') {
                const rawValue = birthstoneInput.value.trim();
                const stoneParts = rawValue.split('-');
                // Use the part after the hyphen (e.g., 'garnet' from 'January-Garnet'), or the raw value if no hyphen.
                const finalValue = stoneParts.length > 1 ? stoneParts[1].toLowerCase() : rawValue;

                additionalData.options.stones.push({
                    index: i,
                    value: finalValue,
                    label: birthstoneDisplay ? birthstoneDisplay.textContent.trim() : rawValue,
                    price: 0
                });
            }
        }

        return additionalData;
    },

    /**
     * Transforms data from the 'photo' template into the standard format.
     * @param {object} photoData - The raw data object from the photo template script.
     * @returns {object} - The data in the standardized format.
     */
    transformPhotoData: function(photoData) {
        const result = { options: {} };
        
        // Always include original and cropper if they exist
        if (photoData?.options?.original) {
            result.options.original = photoData.options.original;
        }
        if (photoData?.options?.cropper) {
            result.options.cropper = photoData.options.cropper;
        }

        // Handle text customization if enabled
        if (photoData?.options?.hasTextCustomization) {
            const fontKeyMap = {
                "'Open Sans', sans-serif": 'NHaasGroteskTXStd-55Rg',
                "'Italianno', cursive": 'Italianno',
                "'Dancing Script', cursive": 'Dancing+Script'
            };

            const selectedFont = photoData.options.selectedFont;
            const selectedSize = photoData.options.selectedSize;
            
            // Add font information
            if (selectedFont) {
                result.options.charmsFont = {
                    type: 'select',
                    key: fontKeyMap[selectedFont.value] || 'NHaasGroteskTXStd-55Rg',
                    label: selectedFont.text.replace('Font: ', '') || 'Classic',
                    factor: 1.2
                };
            }
            
            // Add size information
            if (selectedSize) {
                result.options.charmsSize = {
                    type: 'select',
                    key: selectedSize.value || '20',
                    label: selectedSize.text.replace('Size: ', '') || 'Small',
                    size: parseInt(selectedSize.value) || 20
                };
            }
            
            // Add engraving text if exists
            if (photoData.options.symbolText) {
                result.options.charmsEngraving = photoData.options.symbolText;
            }
        }

        return result;
    }
};
